/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/isInteropObservable */
import{observable as r}from"rxjs/dist/esm/internal/symbol/observable";import{isFunction as e}from"rxjs/dist/esm/internal/util/isFunction";function i(o){return e(o[r])}export{i as isInteropObservable};
//# sourceMappingURL=isInteropObservable.mjs.map